import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3d70dd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-p-2 child-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MasterDataTablePermissionList = _resolveComponent("MasterDataTablePermissionList")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_MasterDataTablePermissionForm = _resolveComponent("MasterDataTablePermissionForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MasterDataTablePermissionList, {
        masterDataPermissions: _ctx.masterDataPermissions,
        loading: _ctx.loading,
        allRoles: _ctx.allRoles,
        onOnEntrySelect: _ctx.onEntrySelect,
        onOnClickDelete: _ctx.openDeleteDialog,
        onOnChangeCheckbox: _ctx.onChangeCheckbox
      }, null, 8, ["masterDataPermissions", "loading", "allRoles", "onOnEntrySelect", "onOnClickDelete", "onOnChangeCheckbox"])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteEntry
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog = false, _ctx.isValidationInvalid = true, _ctx.showValidationMessage = false)),
      onOnConfirm: _ctx.saveMasterDataTablePermission,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText,
      showKeepDialogOpen: _ctx.dialogMode === 'newEntry'
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createVNode(_component_MasterDataTablePermissionForm, {
              masterDataPermission: _ctx.masterDataPermission,
              onUpdate: _ctx.onUpdate,
              showErrorMessage: _ctx.showValidationMessage,
              allRoles: _ctx.dialogMode === 'newEntry' ? _ctx.checkRoles : _ctx.allRoles,
              dialogMode: _ctx.dialogMode
            }, null, 8, ["masterDataPermission", "onUpdate", "showErrorMessage", "allRoles", "dialogMode"])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText", "showKeepDialogOpen"])
  ], 64))
}